import styled from 'styled-components';

import { rem } from '@vimeo/bokeh';
import { slate } from '@vimeo/iris/color';
import { Link } from '@vimeo/iris/typography';
import { tokens } from '@vimeo/ui/tokens';

import { breakpoints } from '../constants';
import H2 from '../H2';

interface WrapperProps {
  isFirst?: boolean;
  isSecond?: boolean;
}

interface FirstItemProps {
  isFirst?: boolean;
  alignContent?: string;
}

interface DescriptionProps {
  textAlign?: string;
}

interface GridWrapperProps {
  bgColor?: string;
}

interface DescriptionWrapperProps {
  isFirst?: boolean;
}

export const Wrapper = styled.section<WrapperProps>`
  margin-top: 100px;
  position: relative;
  overflow: hidden;
  z-index: 5;

  @media (min-width: ${breakpoints.tablet}) {
    margin-top: ${(props) => (props.isFirst ? '230px' : '100px')};
  }

  @media (min-width: ${breakpoints.desktop}) {
    margin-top: ${(props) => (props.isFirst ? '230px' : props.isSecond ? '10%' : '150px')};
  }

  @media (min-width: ${breakpoints.XLDesktop}) {
    margin-top: ${(props) => (props.isFirst ? '230px' : props.isSecond ? '12%' : '150px')};
  }
`;

export const SectionTextWrapper = styled.div<FirstItemProps>`
  width: 100%;
  min-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: ${(props) => (props.isFirst ? '238px' : '38px')};

  align-items: ${(props) => (props.alignContent ? props.alignContent : 'left')};

  @media (min-width: ${breakpoints.tablet}) {
    margin-top: 20%;
  }

  @media (min-width: ${breakpoints.mobile}) {
    margin-top: 20%;
  }

  @media (min-width: ${breakpoints.desktop}) {
    margin-top: ${(props) => (props.isFirst ? 0 : '0')};
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  margin-top: ${tokens.space.page.lg};
  margin-bottom: ${tokens.space.page.sm};
`;

export const FeatureDescription = styled.div`
  margin-top: ${tokens.space.page.xs};
  margin-bottom: ${tokens.space.page.xxs};
  width: 95%;
  @media (min-width: ${breakpoints.tablet}) {
    width: 72.5%;
  }
  @media (min-width: ${breakpoints.desktop}) {
    margin-top: ${tokens.space.page.md};
    width: 91%;
  }
`;

export const Description = styled.div<DescriptionProps>`
  margin-top: ${tokens.space.page.xs};
  margin-bottom: ${tokens.space.page.xxs};
  width: 70%;
  color: rgb(26, 46, 59);
  text-align: ${(props) => (props.textAlign ? props.textAlign : 'center')};
  @media (min-width: ${breakpoints.tablet}) {
    width: 52.5%;
  }
  @media (min-width: ${breakpoints.desktop}) {
    margin-top: ${tokens.space.page.md};
    width: ${(props) => (props.textAlign === 'center' ? '50%' : '71%')};
  }
`;

export const SectionHeader = styled.span`
  display: block;
`;

export const TitleWrapper = styled(H2)<DescriptionProps>`
  margin: unset;
  text-align: ${(props) => (props.textAlign ? props.textAlign : 'left')};

  @media (min-width: ${breakpoints.tablet}) {
    font-size: 35px;
    line-height: 40px;
  }

  @media (min-width: ${breakpoints.desktop}) {
    font-size: 45px;
    line-height: 50px;
  }
`;

export const GridContentWrapper = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
`;

export const FeatureHeader = styled(H2)`
  margin: unset;
  color: #fff;
  text-align: center;
`;

export const GridWrapper = styled.div<GridWrapperProps>`
  background-color: ${(props) => (props.bgColor ? props.bgColor : '#fff')};
  padding: 5% 12.5%;
`;

export const GridContent = styled.div`
  display: inline-flex;
  align-items: normal;
  padding: ${tokens.space.page.xs};

  svg {
    path:first-child {
      fill: ${slate(380)};
    }

    circle:first-child {
      fill: ${slate(380)};
    }
  }

  div:nth-child(2) {
    padding-left: ${tokens.space.page.xs};
  }

  @media (min-width: ${breakpoints.desktop}) {
    width: 50%;
    svg {
      width: 60px;
      height: ${rem(92)};
    }
  }

  //Google Chrome specfics
  @media (min-width: ${breakpoints.mobile}) and (-webkit-min-device-pixel-ratio: 0) {
    svg {
      height: ${rem(92)};
    }
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  @media (min-width: ${breakpoints.desktop}) {
    width: 60%;
  }
`;

export const DescriptionWrapper = styled.div<DescriptionWrapperProps>`
  width: 100%;
  margin: 0;

  @media (min-width: ${breakpoints.tablet}) {
    width: 83.33%;
  }

  @media (min-width: ${breakpoints.desktop}) {
    min-height: 300px;
    width: 33.33%;
    margin: ${(props) => (props.isFirst ? '0 0 150px 0' : '150px 0 0 0')};
  }
`;

export const LearnMore = styled(Link)`
  font-size: 16px;
`;

export const FeatureSectionWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const FeatureStackContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10%;
  align-items: center;
`;
